import * as React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';
import { percentage } from '../../../lib/helpers';
import styles from './styles';

export interface Props {
  classes: any;
  data: any[];
}

export const PricePointText = (props: Props) => {
  const firstMonth = props.data[0];
  const avgDelta = percentage(Math.abs(firstMonth.trendAvg));
  const avgDeltaNoun = firstMonth.trendAvg >= 0 ? 'more' : 'less';

  if (!avgDelta) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', margin: '7.5px 0' }}>
      {firstMonth.trendAvg >= 0 && <TrendingUp htmlColor="#195A50" />}
      {firstMonth.trendAvg < 0 && <TrendingDown htmlColor="#E2658C" />}
      <Typography className={props.classes.trendsText}>
        On average, buyers pay{' '}
        <strong>
          {avgDelta} {avgDeltaNoun}
        </strong>{' '}
        than list price.
      </Typography>
    </div>
  );
};

export default withStyles(styles)(PricePointText);
